import { IModel } from 'core-ts-types';
import * as _4 from 'lodash4';

export interface IPreferencesCampus {
  id: number;
  is_online: boolean;
  name: string;
  rank: number;
  _selected: boolean;
  is_global: boolean;
}

export class PreferencesCampusModel implements IModel {
  private _campuses: IPreferencesCampus[] = [];

  initialize() {
    this.clear();
  }

  clear(): any {
    this._campuses = [];
    return this;
  }

  write(source: IPreferencesCampus[]): PreferencesCampusModel {
    this._campuses = _4.merge(this._campuses, source);
    return this;
  }

  read(): IPreferencesCampus[] {
    return this._campuses;
  }

  get(campusId: number) {
    return _4.find(this._campuses, ['id', campusId]);
  }

  update(source: IPreferencesCampus) {
    return this;
  }
}

angular.module('capability-ng-scheduler').service('ngPreferencesCampusModel', PreferencesCampusModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/models/preferences_campus_model.ts